// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-input-footnote[data-v-359c970c]{font-size:12px;opacity:.8}.banner-decoration-checkbox[data-v-359c970c]{position:relative;display:inline-flex;align-items:flex-start;margin:0;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:var(--border-radius);padding-bottom:5px;height:24px}", ""]);
// Exports
module.exports = exports;
